export default __webpack_public_path__ + "static/media/unlock.1c621dfb.svg";